import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={58}
    height={58}
    viewBox="0 0 58 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle opacity={0.2} cx={29} cy={29} r={29} fill="#74339C" />
    <path
      d="M43.4995 14.5H41.4212L14.5 41.0829V43.4995H16.5219L43.4995 16.5219V14.5Z"
      fill="#636F7C"
    />
    <path
      d="M33.2208 14.5L14.5 33.0275V37.0552L37.321 14.5H33.2208Z"
      fill="#636F7C"
    />
    <path
      d="M25.0365 14.5644L14.5 24.8996V28.9998L28.9998 14.5L25.0365 14.5644Z"
      fill="#636F7C"
    />
    <path
      d="M16.8119 14.5L14.5 16.9166V20.9443L20.9121 14.5H16.8119Z"
      fill="#636F7C"
    />
    <path
      d="M43.5005 20.623L20.623 43.5005H24.7233L43.5005 24.7233V20.623Z"
      fill="#636F7C"
    />
    <path
      d="M43.499 28.833L28.8301 43.5019H32.9303L43.499 32.9332V28.833Z"
      fill="#636F7C"
    />
    <path
      d="M43.4998 37.0312L37.0312 43.4998H41.1315L43.4998 41.1315V37.0312Z"
      fill="#636F7C"
    />
  </svg>
);
export default SVGComponent;
